import { render, staticRenderFns } from "./RoomsSidebar.vue?vue&type=template&id=45c3163c&lang=pug&"
import script from "./RoomsSidebar.vue?vue&type=script&lang=js&"
export * from "./RoomsSidebar.vue?vue&type=script&lang=js&"
import style0 from "./RoomsSidebar.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports